(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/poker/common/assets/javascripts/util.js') >= 0) return;  svs.modules.push('/components/poker/common/assets/javascripts/util.js');

'use strict';

const _svs$components$poker = svs.components.poker.common.constants,
  BrowserStorageConstants = _svs$components$poker.BrowserStorageConstants,
  trackingEvents = _svs$components$poker.trackingEvents;
const _svs$components$Stora = svs.components.Storage,
  EXPIRES_10M = _svs$components$Stora.constants.EXPIRES_10M,
  BrowserStorage = _svs$components$Stora.browser;

const setTwisterBrowserStorage = gameType => {
  BrowserStorage.set(BrowserStorageConstants.OpenWebClientTableKey, BrowserStorageConstants.Domain, {
    openWebClientTable: gameType
  }, EXPIRES_10M, () => {
    svs.components.customer_login.login();
  });
};
const startPokerTwister = gameType => {
  const pokerHome = svs.core.urlMapping.get('pokerHome');
  const isMobile = svs.core.detect.formfactor.mobile();
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!isLoggedIn) {
    setTwisterBrowserStorage(gameType);
  } else {
    const height = window.innerHeight / 2;
    const width = window.innerWidth / 2;
    const setDimensions = isMobile ? 'popup' : "width=".concat(width, ", height=").concat(height);
    window.open("".concat(pokerHome, "/spela/start-table?formFactor=").concat(isMobile ? 'mobile' : 'desktop', "&tableType=").concat(gameType), '', setDimensions);
  }
};
const trackPokerTwisterEvent = trackingObject => {
  if (trackingObject.trackingType === trackingEvents.TRACK_EVENT) {
    svs.components.analytics.trackEvent({
      category: 'Poker',
      action: 'poker_widget',
      opt_label: trackingObject.opt_label
    });
  } else if (trackingObject.trackingType === trackingEvents.PROMO_CLICK && trackingObject.trackingString) {
    svs.components.analytics.trackPromoClick({
      name: trackingObject.trackingString,
      position: parseInt(trackingObject.position, 10)
    });
  }
};
const launchTwisterFromStorage = () => {
  BrowserStorage.get(BrowserStorageConstants.OpenWebClientTableKey, BrowserStorageConstants.Domain, data => {
    if (data !== null && data !== void 0 && data.openWebClientTable) {
      startPokerTwister(data.openWebClientTable);
      BrowserStorage.remove(BrowserStorageConstants.OpenWebClientTableKey, BrowserStorageConstants.Domain);
    }
  });
};

const setTournamentBrowserStorage = tournamentId => {
  BrowserStorage.set(BrowserStorageConstants.OpenWebClientTournamentKey, BrowserStorageConstants.Domain, {
    openWebClientTournament: tournamentId
  }, EXPIRES_10M, () => {
    svs.components.customer_login.login();
  });
};
const startPokerTournament = tournamentId => {
  const pokerHome = svs.core.urlMapping.get('pokerHome');
  const isMobile = svs.core.detect.formfactor.mobile();
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!isLoggedIn) {
    setTournamentBrowserStorage(tournamentId);
  } else {
    const qs = new URLSearchParams();
    qs.append('formFactor', isMobile ? 'mobile' : 'desktop');
    if (tournamentId) {
      qs.append('tournamentId', tournamentId);
    }
    window.open("".concat(pokerHome, "/spela?").concat(qs.toString()), '', 'popup=true,width=1280,height=720');
  }
};
const launchTournamentFromStorage = () => {
  BrowserStorage.get(BrowserStorageConstants.OpenWebClientTournamentKey, BrowserStorageConstants.Domain, data => {
    if (data !== null && data !== void 0 && data.openWebClientTournament) {
      startPokerTournament(data.openWebClientTournament);
      BrowserStorage.remove(BrowserStorageConstants.OpenWebClientTournamentKey, BrowserStorageConstants.Domain);
    }
  });
};

const setGameTypeBrowserStorage = gameType => {
  BrowserStorage.set(BrowserStorageConstants.OpenWebClientGameTypeKey, BrowserStorageConstants.Domain, {
    openWebClientGameType: gameType
  }, EXPIRES_10M, () => {
    svs.components.customer_login.login();
  });
};
const startPokerGameTypeDeeplink = gameType => {
  const pokerHome = svs.core.urlMapping.get('pokerHome');
  const isMobile = svs.core.detect.formfactor.mobile();
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!isLoggedIn) {
    setGameTypeBrowserStorage(gameType);
  } else {
    const qs = new URLSearchParams();
    qs.append('formFactor', isMobile ? 'mobile' : 'desktop');
    if (gameType) {
      qs.append('gameLink', gameType);
    }
    window.open("".concat(pokerHome, "/spela?").concat(qs.toString()), '', 'popup=true,width=1280,height=720');
  }
};
const launchGameTypeFromStorage = () => {
  BrowserStorage.get(BrowserStorageConstants.OpenWebClientGameTypeKey, BrowserStorageConstants.Domain, data => {
    if (data !== null && data !== void 0 && data.openWebClientGameType) {
      startPokerGameTypeDeeplink(data.openWebClientGameType);
      BrowserStorage.remove(BrowserStorageConstants.OpenWebClientGameTypeKey, BrowserStorageConstants.Domain);
    }
  });
};

const exported = {
  trackPokerTwisterEvent,
  startPokerTwister,
  startPokerTournament,
  startPokerGameTypeDeeplink,
  launchTwisterFromStorage,
  launchTournamentFromStorage,
  launchGameTypeFromStorage
};
if (!svs.isServer) {
  svs.components.poker.common.util = exported;
}

 })(window);